import { CircularButtonProps } from "@/components/CircularButton";
import CircularRectTextButton from "@/components/CircularButton/styled/CircularRectTextButton";
import { borderRadius } from "@/utils/borderRadius";
import { spacing } from "@/utils/spacing";
import { themeColors } from "@/utils/themeColors";
import clsx from "clsx";

const ChatSuggestionOption = ({ children, sx, className, onClick, ...props }: CircularButtonProps) => {
    const isButton = typeof onClick === "function";

    return (
        <CircularRectTextButton
            className={clsx("secondaryTextBold1", className)}
            component={isButton ? "button" : "div"}
            onClick={isButton ? onClick : undefined}
            disabled={!isButton}
            sx={{
                justifyContent: "flex-start",
                gap: spacing.XS,
                borderRadius: borderRadius.smallModal,
                border: `1px solid ${themeColors.neutral1}`,
                padding: spacing.SM,
                height: "5.2rem",
                transition: "background-color 0.3s",
                cursor: isButton ? "pointer" : "default",
                "&:hover": isButton
                    ? {
                          //   boxShadow: "inset 0 0 0 10em rgba(0, 0, 0, 0.2)",
                          outline: `1px solid ${themeColors.neutralBlack}`,
                      }
                    : {
                          boxShadow: "none",
                      },
                "&:active": isButton
                    ? {
                          //   boxShadow: "inset 0 0 0 10em rgba(0, 0, 0, 0.35)",
                          outline: `1px solid ${themeColors.neutralBlack}`,
                      }
                    : {
                          boxShadow: "none",
                      },
                textAlign: "left",
                ...sx,
            }}
            {...props}>
            {children}
        </CircularRectTextButton>
    );
};

export default ChatSuggestionOption;
